import { createSlice } from "@reduxjs/toolkit";
import {  fetchContent } from "../actions/contentAction";


const initialState = {
  isLoading: false,
  resourceHeader: [
    "S.No.",
    "Title",
    "Type",
    "Status",
    "Submitted On",
    "Visibility",
    "Action",
  ],
  projectHeader: [
    "S.No.",
    "Title",
    "Subimitted By",
    // "Category",
    "Status",
    "Subimitted On",
    "Action"
  ],
  contentList: {},

};

const contentSlice = createSlice({
  name: "coach",
  initialState: initialState,
  extraReducers: (builder) => {

    // fetchContent
    builder.addCase(fetchContent.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchContent.fulfilled, (state, action) => {
      const { data } = action?.payload ?? {};
      const grouped = Object.groupBy(data, (p) => p.content_type);
      state.contentList = {
        all: data,
        ...grouped,
      };

      state.isLoading = false;
    });
    builder.addCase(fetchContent.rejected, (state, action) => {
      state.isLoading = false;
    });

  },
});

export default contentSlice.reducer;
